import React, { Component } from "react";

import "./Tooltip.scss";

class Hover extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.onClick = this.onClick.bind(this);
  }

  onClick() {

    var wasVisible = this.first.classList.contains("visible");

    var elements = document.getElementsByClassName('visible');
    for (var i = 0; i < elements.length; i++) {
      var item = elements[i];
      item.classList.remove("visible");
    }

    if(!wasVisible){
      this.first.classList.add("visible");
    }
    
  }

  render() {
    return (
      <div
        ref={elem => (this.hover = elem)}
        className="hover"
        onClick={this.onClick}
      >
        <div ref={elem => (this.no = elem)} className="hover__no-hover">
          {this.props.children}
        </div>
        <div ref={elem => (this.first = elem)} className="hover__hover">
          {this.props.onHover}
        </div>
      </div>
    );
  }
}

export default Hover;
